import React from "react";
import UploaderGeneralInfosEncapsulatedBisMobileV2 from "../../Updloader/UploaderGeneralInfosEncapsulatedBisMobileV2";

function GeneralInformationV2PassportSection(props) {
  const { translate, uploaderProps } = props;

  return (
    <div style={{ width: "100%", marginLeft: "0px ", marginTop: "20px", paddingBottom: "20px", display: "flex", flexDirection: "column" }}>
      <div style={{ width: "100%", fontSize: "22px", fontWeight: "600", textAlign: "left", paddingTop: "10px", borderTop: "1px solid #cccccc" }}>
        <span id="passport-picture" style={{ fontSize: "14px", fontWeight: "600", paddingLeft: "10px" }}>{translate("PassportPictures")}</span>
      </div>
      <div style={{ width: "100%", display: "flex", justifyContent: "flex-start", alignContent: "center", alignItems: "center", paddingLeft: "10px" }}>
        <UploaderGeneralInfosEncapsulatedBisMobileV2 {...uploaderProps} />
      </div>
    </div>
  );
}

export default GeneralInformationV2PassportSection;
